import { render } from "./BondSettingView.vue?vue&type=template&id=31d6ff02&scoped=true"
import script from "./BondSettingView.vue?vue&type=script&lang=js"
export * from "./BondSettingView.vue?vue&type=script&lang=js"

import "./BondSettingView.vue?vue&type=style&index=0&id=31d6ff02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d6ff02"]])

export default __exports__